import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { take } from 'rxjs/operators';
import { BaseComponent } from '@shared/components/base-component/base.component';
import { NotificationItem } from '@shared-features/models/notification-item';
import { NotificationService } from '@shared/services/notification.service';
import { NotificationsApiService } from '@features/notifications/services/notifications-api.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent extends BaseComponent implements OnInit, OnDestroy {
  @Output() closeNotificationClicked = new EventEmitter();

  public Arr = Array;
  public notifications: NotificationItem[] = [];

  offset = 0;
  limit = 10;
  hasMoreNotifications = true;

  constructor(
    private notificationService: NotificationService,
    private notificationsApiService: NotificationsApiService
  ) {
    super();
  }

  ngOnInit(): void {
    this.getAllNotification();
  }

  private getAllNotification(): void {
    this.load(
      this.notificationsApiService.getAllNotifications({ offset: this.offset, limit: this.limit }),
      {
        isLoadingTransparent: true,
        emptyContentCheck: (notifications) =>
          Array.isArray(notifications) && !notifications?.length,
      }
    ).subscribe(
      (data) => {
        this.notifications = [...this.notifications, ...(data as unknown as NotificationItem[])];
        this.hasMoreNotifications = (data as unknown as NotificationItem[])?.length > 0;
      },
      (error) => {
        if (error && this.notifications.length) {
          this.hasMoreNotifications = false;
        }
      }
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  // UI Events
  onNotificationClicked(notification: NotificationItem): void {
    this.notificationsApiService
      .markAsRead(+notification.id)
      .pipe(take(1))
      .subscribe(() => {
        this.notifications.forEach((n) => {
          if (n.id === notification.id) {
            n.isRead = true;
          }
        });
      });
    this.notificationService.navigateToNotificationTarget(notification);
    this.closeNotificationClicked.emit();
  }

  loadMore(): void {
    this.offset += 1;
    this.getAllNotification();
  }
}
